import { AddAnimalToSubscriptionResult } from '@lyka-pet-food/contracts'
import { CreateDogSchema } from '@repo/api-types'
import {
  DogBreedReturnDto,
  DogFoodAllergenReturnDto,
  DogFoodTypeReturnDto,
  DogHealthIssueReturnDto,
  RetrieveDogReturnDto,
  UpdateAnimalDto,
} from '@repo/api-types/entities'
import { initContract } from '@ts-rest/core'
import z from 'zod'

const c = initContract()

export const animalsContract = c.router(
  {
    getDogs: {
      method: 'GET',
      path: '',
      summary: 'Get all dogs for the specified user',
      responses: {
        200: c.type<Array<RetrieveDogReturnDto>>(),
        401: c.type<{ error: string }>(),
        403: c.type<{ error: string }>(),
        500: c.type<{ error: string }>(),
      },
    },
    getDogsData: {
      method: 'GET',
      path: '/metadata',
      summary: 'Get dog breeds, health issues, food types, and allergens',
      responses: {
        200: c.type<{
          breeds: DogBreedReturnDto[]
          healthIssues: DogHealthIssueReturnDto[]
          foodTypes: DogFoodTypeReturnDto[]
          foodAllergens: DogFoodAllergenReturnDto[]
        }>(),
        401: c.type<{ error: string }>(),
        403: c.type<{ error: string }>(),
        500: c.type<{ error: string }>(),
      },
    },
    createDog: {
      method: 'POST',
      path: '',
      summary: 'Create a new dog for the specified user',
      body: CreateDogSchema,
      responses: {
        200: c.type<AddAnimalToSubscriptionResult>(),
        401: c.type<{ error: string }>(),
        403: c.type<{ error: string }>(),
        500: c.type<{ error: string }>(),
      },
    },
    updateDog: {
      method: 'PATCH',
      path: '/:id',
      summary: 'Update a dog by ID',
      body: z.object({
        dog: z.custom<UpdateAnimalDto>(),
      }),
      responses: {
        200: c.type<UpdateAnimalDto>(),
        401: c.type<{ error: string }>(),
        403: c.type<{ error: string }>(),
        500: c.type<{ error: string }>(),
      },
    },
  },
  {
    pathPrefix: '/users/me/dogs',
  },
)
